import { usePricelistProductSalesChannelDeleteMutation } from "@/generated/graphql";

export const usePricelistProductSalesChannelDelete = () => {
	const [, remove] = usePricelistProductSalesChannelDeleteMutation();

	const deletePricelistProductSalesChannel = (
		pricelistProductSalesChannelID: string,
	) => {
		return remove({ pricelistProductSalesChannelID });
	};

	return {
		deletePricelistProductSalesChannel,
	};
};
